"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var measurement_unit_1 = require("../../shared/models/measurement_unit");
var size_chart_1 = require("../../shared/models/size_chart");
var lodash_1 = __importDefault(require("lodash"));
var global_1 = require("./global");
/* Actions */
var MeasurementsActionType;
(function (MeasurementsActionType) {
    MeasurementsActionType["CHANGE_UNITS"] = "measurements_CHANGE_UNIT";
    MeasurementsActionType["UPDATE_TOP_LEVEL_OPTION"] = "measurements_UPDATE_TOP_LEVEL";
    MeasurementsActionType["UPDATE_SIZE_CHART_OPTION"] = "measurements_UPDATE_SIZE_CHART_OPTION";
    MeasurementsActionType["UPDATE_MEASUREMENTS"] = "measurements_UPDATE_MEASUREMENTS";
    MeasurementsActionType["UPDATE_GLOBAL_MEASUREMENT"] = "measurements_UPDATE_GLOBAL_MEASUREMENT";
    MeasurementsActionType["CLEAR_END_RANGES"] = "measurements_CLEAR_END_RANGES";
    MeasurementsActionType["RENDER_PRODUCT_MEASUREMENTS"] = "measurements_RENDER_PRODUCT_MEASUREMENTS";
})(MeasurementsActionType = exports.MeasurementsActionType || (exports.MeasurementsActionType = {}));
var MeasurementUpdate;
(function (MeasurementUpdate) {
    MeasurementUpdate[MeasurementUpdate["START"] = 0] = "START";
    MeasurementUpdate[MeasurementUpdate["END"] = 1] = "END";
})(MeasurementUpdate = exports.MeasurementUpdate || (exports.MeasurementUpdate = {}));
var initialState = {
    sizeChart: size_chart_1.EmptySizeChart,
    globalMeasurement: {
        unit: measurement_unit_1.metric,
        measurements: {},
    },
    needsSave: false,
};
exports.reducer = function (oldState, action) {
    if (oldState === void 0) { oldState = initialState; }
    switch (action.type) {
        case MeasurementsActionType.RENDER_PRODUCT_MEASUREMENTS:
            return extractStateFromQueryResult(action.productQuery, oldState);
        case MeasurementsActionType.UPDATE_TOP_LEVEL_OPTION:
            return __assign({}, oldState, { sizeChart: size_chart_1.updateSizeChartTopLevel(oldState.sizeChart, action.newOption), needsSave: true });
        case MeasurementsActionType.UPDATE_SIZE_CHART_OPTION:
            return __assign({}, oldState, { sizeChart: size_chart_1.updateSelectedOption(oldState.sizeChart, action.option, action.set), needsSave: true });
        case MeasurementsActionType.UPDATE_MEASUREMENTS:
            return __assign({}, oldState, { sizeChart: size_chart_1.upsertMeasurements(oldState.sizeChart, action.affectedVariants, action.dimensionKey, action.newMeasurement, action.update), needsSave: true });
        case MeasurementsActionType.UPDATE_GLOBAL_MEASUREMENT: {
            return __assign({}, oldState, { globalMeasurement: size_chart_1.updateGlobalMeasurement(oldState.globalMeasurement, action.dimensionKey, action.newMeasurement, action.update), needsSave: true });
        }
        case MeasurementsActionType.CHANGE_UNITS: {
            return __assign({}, oldState, { sizeChart: size_chart_1.updateSizeChartUnit(oldState.sizeChart, action.unit), globalMeasurement: size_chart_1.updateGlobalMeasurementUnit(oldState.globalMeasurement, action.unit) });
        }
        case MeasurementsActionType.CLEAR_END_RANGES:
            var newSizeChart = __assign({}, oldState.sizeChart);
            var newGlobalMeasurements_1 = __assign({}, oldState.globalMeasurement);
            // individual
            newSizeChart.measurements =
                newSizeChart.measurements.map(function (measurement) {
                    var newMeasurement = __assign({}, measurement);
                    newMeasurement.endLength = undefined;
                    newMeasurement.endLengthDisplay = undefined;
                    return newMeasurement;
                });
            // global
            Object
                .keys(newGlobalMeasurements_1.measurements)
                .forEach(function (dimensionKey) {
                newGlobalMeasurements_1.measurements[dimensionKey].end = undefined;
            });
            return __assign({}, oldState, { sizeChart: newSizeChart, globalMeasurement: newGlobalMeasurements_1, needsSave: true });
        case global_1.GlobalActionType.CLEAR_SAVE:
            return __assign({}, oldState, { needsSave: false });
        default:
            return oldState;
    }
};
var extractStateFromQueryResult = function (query, oldState) {
    var shopifyProduct = query.shopify_productByHandle;
    var measuredProduct = query.product;
    var countryCode = query.currentStore.countryCode;
    var convertToInches = countryCode === "CA" || countryCode === "US";
    var variants = measuredProduct
        && measuredProduct.variants
        || [];
    var measurements = lodash_1.default.flatMap(variants, function (mv) {
        return mv.measurements.map(function (m) {
            var endLength = m.endLengthM ?
                (convertToInches ?
                    size_chart_1.cmToInches(m.endLengthM * 100)
                    : m.endLengthM * 100)
                : undefined;
            return {
                variantId: mv.shopifyVariantId,
                dimensionKey: m.dimension.id,
                startLength: (convertToInches ?
                    size_chart_1.cmToInches(m.startLengthM * 100)
                    : m.startLengthM * 100),
                endLength: endLength,
            };
        });
    });
    var jsonOptions = shopifyProduct
        && shopifyProduct.options
        || [];
    var optionLabels = jsonOptions.map(function (jo) { return jo.name; });
    var topLevelOptionValue = measuredProduct
        && measuredProduct.topLevelOption;
    var topLevelOptionLabel;
    switch (topLevelOptionValue) {
        case "option1": {
            topLevelOptionLabel = optionLabels[0];
            break;
        }
        case "option2": {
            topLevelOptionLabel = optionLabels[1];
            break;
        }
        case "option3": {
            topLevelOptionLabel = optionLabels[2];
            break;
        }
        default: {
            topLevelOptionLabel = optionLabels[0];
            break;
        }
    }
    var availableOptionLabels = [];
    if (measuredProduct) {
        if (measuredProduct.option1InSizeChart && optionLabels[0]) {
            availableOptionLabels.push(optionLabels[0]);
        }
        if (measuredProduct.option2InSizeChart && optionLabels[1]) {
            availableOptionLabels.push(optionLabels[1]);
        }
        if (measuredProduct.option3InSizeChart && optionLabels[2]) {
            availableOptionLabels.push(optionLabels[2]);
        }
    }
    var sizeChart = {
        unit: convertToInches ? measurement_unit_1.imperial : measurement_unit_1.metric,
        measurements: measurements,
        topLevelOptionLabel: topLevelOptionLabel,
        availableOptionLabels: availableOptionLabels,
    };
    var dimensionMeasurements = {};
    measurements.forEach(function (m) {
        var currentMeasurements = dimensionMeasurements[m.dimensionKey] || [];
        dimensionMeasurements[m.dimensionKey] = currentMeasurements.concat([
            m,
        ]);
    });
    // generate global measurements by looking at
    // the same start / end for a given dimensionId
    var globalMeasurementValues = {};
    Object.keys(dimensionMeasurements).forEach(function (dimensionKey) {
        var measurementsForDimension = dimensionMeasurements[dimensionKey];
        var startValues = lodash_1.default.uniqBy(measurementsForDimension, function (m) {
            return m.startLength;
        });
        var endValues = lodash_1.default.uniqBy(measurementsForDimension, function (m) {
            return m.endLength;
        });
        var startIsUnique = startValues.length === 1;
        var endIsUnique = endValues.length === 1;
        var measurementCoversAllVariants = measurementsForDimension.length === variants.length;
        var startIsGlobal = startIsUnique && measurementCoversAllVariants;
        var endIsGlobal = endIsUnique && measurementCoversAllVariants;
        if (startIsGlobal && endIsGlobal) {
            globalMeasurementValues[dimensionKey] = {
                start: { value: startValues[0].startLength },
                end: endValues[0].endLength ? {
                    value: endValues[0].endLength,
                } : undefined,
            };
        }
        else if (startIsGlobal) {
            globalMeasurementValues[dimensionKey] = {
                start: { value: startValues[0].startLength },
            };
        }
        else if (endIsGlobal && endValues[0].endLength) {
            globalMeasurementValues[dimensionKey] = {
                start: { value: 0 },
                end: { value: endValues[0].endLength },
            };
        }
    });
    var globalMeasurement = {
        unit: measurement_unit_1.metric,
        measurements: globalMeasurementValues,
    };
    return {
        sizeChart: sizeChart,
        globalMeasurement: globalMeasurement,
        needsSave: oldState.needsSave,
    };
};
